import { useQuery } from "react-query";
import { tokens } from "marvin-auth-kit/dist/tokens";

export function useImageWithToken(imageUrl: string) {
  const { token } = tokens.get();
  const headers = (() => {
    const headers = new Headers();
    if (token) headers.append("Authorization", `Bearer ${token}`);
    return headers;
  })();

  function queryFn(imageUrl: string) {
    return fetch(imageUrl, { headers })
      .then((res) => res.blob())
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  }

  return useQuery(["image", imageUrl], () => queryFn(imageUrl));
}
